import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import SubMotivoBajaService from '../../services/subMotivoBaja.service';

const SelectSubMotivoBaja = ({id, value, onChange, isInvalid, isClearable,isMulti, filterId}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const actualizar = async() =>{
        await SubMotivoBajaService.getAll().then((response) => {
            setItems(response);
        });
    }
    useEffect(() => {
        actualizar();
    }, []);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    useEffect(() => {
        const newOptions = items?.map((item) => {
            return {
                value: item.id_smb,
                label: `${item?.tipoCategoria_smb}-${item?.nombre_smb}`,
            };
        });
        if((Array.isArray(filterId) && filterId?.length > 0)){
            const filteredOptions = newOptions.filter(option => filterId.includes(option.value));
            setOptions(filteredOptions);
        }else{
            setOptions(newOptions);
        }
        if (typeof value === 'string' || typeof value === 'number') {
            setSelectedValue(
                newOptions.find((opt) => opt.value === value)
            );
        } else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = items.find(it=>it.id_smb === va);
                if(item){
                    return {
                        label: `${item?.tipoCategoria_smb}-${item?.nombre_smb}`,
                        value: item.id_smb,
                    };
                }
                return null
            }))
        }
    }, [items,value,filterId]);

    return (
        <Select
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectSubMotivoBaja.defaultProps = {
    isClearable: false
};

export default SelectSubMotivoBaja;
